// Même liste implicite que la page V1 pour les campagnes créées avant le stockage
// explicite de config.sections. Une liste enregistrée, même vide, fait foi.
const DEFAULT_SECTIONS = [
    {id: "DATECOUNTER", type: "DATECOUNTER"},
    {id: "TEAMPROGRESS", type: "TEAMPROGRESS"},
    {id: "PRODUCTS", type: "PRODUCTS"},
    {id: "DONORS", type: "DONORS"},
]

export function orderedVisibleSections(sections) {
    return (Array.isArray(sections) ? sections : DEFAULT_SECTIONS)
        .filter(section => section && typeof section.type === "string" && section.hidden !== true)
}

// La galerie est un choix direct. Les paliers sans fréquence propre y sont montrés
// comme dons uniques ; le formulaire doit reprendre exactement ce même rythme.
export function showcaseChoice(giving, product) {
    return giving.mode === "CHOICE" && product?.frequency === "MONTHLY" ? "MONTHLY" : "ONCE"
}
